// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * General application styles used to override the user-agent styles.
 * These styles are applied at a high level to help ensure consistency throughout the application.
 */
a {
  color: inherit;
}

input,
select,
textarea,
button {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
}

html,
body {
  height: 100%;
  width: 100%;
}

body {
  display: flex;
  font-family: "Segoe UI", "-apple-system", BlinkMacSystemFont, Roboto, "Helvetica Neue", Helvetica, Ubuntu, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.875rem;
  padding: 0;
  margin: 0;
}

ul {
  padding: 0;
}

li {
  list-style: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 600;
}

/*# sourceMappingURL=override.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Core/override.scss","webpack://./../azure-devops-ui/bin/Core/override.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AACA;;;EAAA;AAKA;EACI,cAAA;ACDJ;;ADIA;;;;EAII,cAAA;EACA,oBAAA;EACA,kBAAA;ACDJ;;ADIA;;EAEI,YAAA;EACA,WAAA;ACDJ;;ADIA;EACI,aAAA;EACA,sLEoOS;EFnOT,mBAAA;EACA,UAAA;EACA,SAAA;ACDJ;;ADIA;EACI,UAAA;ACDJ;;ADIA;EACI,gBAAA;ACDJ;;ADIA;;;;;;EAMI,gBEsPiB;ADvPrB;;AAEA,uCAAuC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
